import userAPI from 'resources/user'

export const saveNPS = payload => new Promise((resolve, reject) => {
  userAPI.salvarPesquisaNps(payload).then(resolve).catch(reject)
})
